// extracted by mini-css-extract-plugin
export var childrenContainer = "_3e-0";
export var virtualScrollArea = "_3e-1";